'use strict';

const {burgerNav} = require('./burgerNav/burgerNav');

import Swiper from 'swiper/bundle';
import $ from 'jquery';

jQuery(document).ready(function () {
    initSwiper();
    handleMobileMenu();
    initializeAccordion();
    burgerNav();
});

// Swiper Slider
function initSwiper() {
    new Swiper('.value-swiper', {
        grabCursor: true,
        slidesPerView: 1,
        loop: true,
        speed: 600,
        pagination: { el: '.swiper-pagination', clickable: true },
        navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
        breakpoints: {
            768: {
                slidesPerView: 3,
                effect: 'coverflow',
                coverflowEffect: {
                    rotate: 0,
                    stretch: 50,
                    depth: 150,
                    modifier: 1,
                    slideShadows: false
                }
            }
        }
    });
}

// Mobile Menu
function handleMobileMenu() {
    const $burger = $('#burgerToggle');
    const $menu = $('#mobileMenu');

    $burger.on('click', function () {
        $menu.toggleClass('active');
    });
}

// Accordion
function initializeAccordion() {
    $('.accordion-item').on('click', function (e) {
        if ($(e.target).closest('a, button').length > 0) return;

        const $clickedItem = $(this);

        if ($clickedItem.hasClass('open')) {
            $clickedItem.removeClass('open');
        } else {
            $('.accordion-item').not($clickedItem).removeClass('open');
            $clickedItem.addClass('open');
        }
    });
}
